import {
  DecorativeElement,
  COMPONENTS,
  DOT_COLORS,
  DOT_CLASSES,
} from "../../../componentsGLob/Decorative/decorative-element.config";

export const HERO_DECORATIVES: DecorativeElement[] = [
  {
    id: "hero-coworking-bee-1",
    type: "bee",
    Component: COMPONENTS.Bee,
    position: "top-[3%] left-[18%]",
    animation: {
      animate: {
        x: [0, 15, 30, 15, 0, -15, -30, -15, 0],
        y: [0, -10, 0, 10, 20, 10, 0, -10, 0],
        rotate: [0, 15, 0, -15, 0, 15, 0, -15, 0],
      },
      transition: {
        duration: 20,
        repeat: Infinity,
        repeatType: "loop",
        ease: "easeInOut",
      },
    },
    className: "hidden xl:block",
  },
  {
    id: "hero-coworking-arrow-1",
    type: "arrow",
    Component: COMPONENTS.ArrowIcon,
    position: "top-[35%] right-[10%] md:right-[15%]",
    animation: {
      animate: {
        y: [0, 16, 0],
      },
      transition: {
        duration: 1.8,
        repeat: Infinity,
        ease: "easeInOut",
      },
    },
    className:
      "w-16 h-16 md:w-20 md:h-20 opacity-90 rotate-[120deg] hidden xl:block",
  },
  {
    id: "hero-coworking-dot-red-1",
    type: "dot",
    Component: COMPONENTS.Dot,
    position: "top-[9%] right-[10%]",
    animation: {
      animate: {
        x: [0, 8, -6, 4, 0],
        y: [0, -10, 5, -6, 0],
        rotate: [0, 5, -5, 3, 0],
      },
      transition: {
        duration: 10,
        repeat: Infinity,
        ease: "easeInOut",
      },
    },
    className: `${DOT_COLORS.red} ${DOT_CLASSES.small} hidden xl:block`,
  },
  {
    id: "hero-coworking-dot-yellow-1",
    type: "dot",
    Component: COMPONENTS.Dot,
    position: "top-[15%] right-[5%]",
    animation: {
      animate: {
        x: [0, 10, -10, 5, 0],
        y: [0, -10, 10, -5, 0],
        rotate: [0, 4, -4, 2, 0],
      },
      transition: {
        duration: 12,
        repeat: Infinity,
      },
    },
    className: `${DOT_COLORS.yellow} ${DOT_CLASSES.small} hidden xl:block`,
  },
  {
    id: "hero-coworking-dot-cyan-1",
    type: "dot",
    Component: COMPONENTS.Dot,
    position: "top-[5%] right-[5%]",
    animation: {
      animate: {
        x: [0, 7, -5, 3, 0],
        y: [0, -8, 5, -4, 0],
        rotate: [0, 6, -6, 4, 0],
      },
      transition: {
        duration: 22,
        repeat: Infinity,
      },
    },
    className: `${DOT_COLORS.cyan} ${DOT_CLASSES.medium} hidden xl:block`,
  },
  {
    id: "hero-coworking-dot-red-2",
    type: "dot",
    Component: COMPONENTS.Dot,
    position: "bottom-[7%] left-[10%]",
    animation: {
      animate: {
        x: [0, 7, -5, 3, 0],
        y: [0, -8, 5, -4, 0],
        rotate: [0, 6, -6, 4, 0],
      },
      transition: {
        duration: 13,
        repeat: Infinity,
        ease: "easeInOut",
      },
    },
    className: `${DOT_COLORS.red} ${DOT_CLASSES.small} hidden xl:block`,
  },
  {
    id: "hero-coworking-dot-yellow-2",
    type: "dot",
    Component: COMPONENTS.Dot,
    position: "bottom-[20%] left-[10%]",
    animation: {
      animate: {
        x: [0, 8, -8, 5, 0],
        y: [0, -10, 8, -5, 0],
        rotate: [0, 7, -7, 3, 0],
      },
      transition: {
        duration: 15,
        repeat: Infinity,
        ease: "easeInOut",
      },
    },
    className: `${DOT_COLORS.yellow} ${DOT_CLASSES.small} hidden xl:block`,
  },
  {
    id: "hero-coworking-dot-cyan-2",
    type: "dot",
    Component: COMPONENTS.Dot,
    position: "bottom-[10%] left-[5%]",
    animation: {
      animate: {
        x: [0, 12, -12, 8, 0],
        y: [0, -12, 12, -8, 0],
        rotate: [0, 9, -9, 5, 0],
      },
      transition: {
        duration: 20,
        repeat: Infinity,
        ease: "easeInOut",
      },
    },
    className: `${DOT_COLORS.cyan} ${DOT_CLASSES.medium} hidden xl:block`,
  },
];
